<p-form-wrapper
  id="profil"
  *ngIf="userToEdit"
  titleWrapper="Profil utilisateur"
>
  <div body class="px-4">
    <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
      <strong>Erreur ! </strong>
      {{ errorMsg }}
    </div>

    <div
      *ngIf="successMsg && !errorMsg"
      class="alert alert-success"
      role="alert"
    >
      {{ successMsg }}
    </div>

    <div class="mb-3">
      <p-input
        [formControl]="this.profileFormGroup.controls.login"
        id="login"
        name="login"
        label="Identifiant"
        errorMessage="Identifiant obligatoire"
        [disabled]="true"
        [hideRequiredStar]="true"
      ></p-input>
    </div>

    <div class="mb-3">
      <p-input
        [formControl]="this.profileFormGroup.controls.nom"
        id="nom"
        name="nom"
        label="Nom"
        errorMessage="Nom obligatoire"
        [helpText]="
          !canEdit.nom
            ? 'Votre nom est issu de ID.NOT. Pour le modifier, rendez-vous sur votre compte ID.NOT.'
            : undefined
        "
        [disabled]="!canEdit.nom"
        (keyup.enter)="saveProfile()"
        [hideRequiredStar]="true"
      ></p-input>
    </div>

    <div class="mb-3">
      <p-input
        [formControl]="this.profileFormGroup.controls.prenom"
        id="prenom"
        name="prenom"
        label="Prénom"
        errorMessage="Prenom obligatoire"
        [helpText]="
          !canEdit.prenom
            ? 'Votre prénom est issu de ID.NOT. Pour le modifier, rendez-vous sur votre compte ID.NOT.'
            : undefined
        "
        [disabled]="!canEdit.prenom"
        (keyup.enter)="saveProfile()"
        [hideRequiredStar]="true"
      ></p-input>
    </div>

    <div class="mb-3">
      <p-input
        [formControl]="this.profileFormGroup.controls.email"
        id="email"
        name="email"
        label="Email"
        errorMessage="Email obligatoire"
        [helpText]="
          !canEdit.email
            ? 'Votre email est issu de ID.NOT. Pour le modifier, rendez-vous sur votre compte ID.NOT.'
            : undefined
        "
        [disabled]="!canEdit.email"
        [hideRequiredStar]="true"
        (keyup.enter)="saveProfile()"
      ></p-input>
    </div>

    <div class="mb-3">
      <p-input
        [formControl]="this.profileFormGroup.controls.phone"
        id="phone"
        name="phone"
        label="Téléphone"
        errorMessage="Téléphone obligatoire"
        [disabled]="!canEdit.phone"
        (keyup.enter)="saveProfile()"
        [hideRequiredStar]="true"
      ></p-input>
    </div>

    <div *ngIf="displayEditButton" class="d-flex justify-content-between mt-4">
      <p-button
        id="btn-modifier"
        label="Modifier"
        [width]="75"
        class="col-5"
        [title]="
          !profileFormGroup.valid
            ? 'Veuillez remplir tous les champs obligatoire'
            : 'Modifier'
        "
        [disabled]="
          !(isBasicInfosDirty || isEmailDirty) ||
          isEditLoading ||
          !profileFormGroup.valid
        "
        [loading]="isEditLoading"
        (click)="saveProfile()"
      ></p-button>
    </div>
  </div>
</p-form-wrapper>

<p-modal
  *ngIf="isModalOTPOpen"
  [modalId]="profilModalId.OTP_MODAL"
  title="Code de validation"
  (cancel)="onCloseOtpModal()"
>
  <div *ngIf="errorValidationCodeMsg" class="alert alert-danger" role="alert">
    <strong>Erreur ! </strong>
    {{ errorValidationCodeMsg }}
  </div>
  <div class="d-flex flex-column align-items-center">
    <p-input
      [formControl]="this.otpForm.controls.otp"
      id="otp"
      name="otp"
      label="Code de validation"
      errorMessage="Code de validation obligatoire"
      [disabled]="!canEdit.email"
      (keyup.enter)="saveProfile()"
    ></p-input>

    <p-button
      id="btn-valider"
      label="Valider"
      [disabled]="!isOtpDirty || isValidationCodeLoading || !otpForm.valid"
      [loading]="isValidationCodeLoading"
      (click)="validerCodeVerification()"
    ></p-button>
  </div>
</p-modal>
